import React, { useState } from 'react';
import { Container, Row, Col, Card } from 'react-bootstrap';
import '../styles/patientSummary.css';

const CardGrid = ({ cardData }) => {
  const [hoveredCardIdentifier, setHoveredCardIdentifier] = useState(null);

  const getCardStyle = (cardId) => ({
    transform: hoveredCardIdentifier === cardId ? 'scale(1.015)' : 'scale(1)',
    boxShadow: hoveredCardIdentifier === cardId ? '0 .5rem 1rem rgba(0,0,0,.15)' : '0 .125rem .25rem rgba(0,0,0,.075)',
    transition: 'transform 0.2s ease-in-out, box-shadow 0.2s ease-in-out',
  });

  const renderCardText = (card) => {
    if (card.title === 'Postings') {
      return (
        <table className="custom-table">
          <thead>
            <tr>
              <th>Posts</th>
              <th>Date</th>
            </tr>
          </thead>
          <tbody>
            {card.text.split('\n').map((line, idx) => {
              const match = line.replace(/^•\s*/, '').split(' - ');
              return (
                <tr key={idx}>
                  <td>{match[0]}</td>
                  <td>{match[1] || ''}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      );
    }
    return (
      <ul className="card-list">
        {card.text.split('\n').map((line, idx) => (
          <li key={idx}>{line.replace(/^•\s*/, '')}</li>
        ))}
      </ul>
    );
  };

  const renderRow = (cards, columns) => (
    <Row className="flex-grow-1sss g-2 mb-2">
      {cards.map((card) => (
        <Col key={card.id} xs={12} sm={6} md={12 / columns}>
          <Card
            className="h-100 rounded-0 p-0 mb-2"
            style={getCardStyle(card.id)}
            onMouseEnter={() => setHoveredCardIdentifier(card.id)}
            onMouseLeave={() => setHoveredCardIdentifier(null)}
          >
            <div className="card-title-custom">{card.title}</div>
            <div className="cardTextContent card-scrollable-content">{renderCardText(card)}</div>
          </Card>
        </Col>
      ))}
    </Row>
  );

  return (
    <Container fluid className="d-flex flex-column" style={{ marginTop: '125px', marginBottom: '20px' }}>
      {renderRow(cardData.slice(0, 4), 4)}
      {renderRow(cardData.slice(4, 7), 3)}
      {renderRow(cardData.slice(7, 10), 3)}
    </Container>
  );
};

export default CardGrid;
